/**
 * Memoire locale d'une validation de mise en forme laissee en attente.
 *
 * Les propositions sont deja persistees en base a chaque fin de boucle : rien
 * n'est perdu quand la fenetre se ferme. Ce qui manquait, c'est le chemin du
 * RETOUR — aucun ecran n'allait les rechercher. On retient donc l'identifiant
 * de la conversation, et l'endpoint de statut existant fait le reste : son
 * repli relit la base quand le registre en memoire a ete vide.
 *
 * Portee : ce navigateur. Une validation preparee sur une autre machine ne
 * sera pas proposee ici — elle reste en base, simplement personne ne l'y
 * cherche. Limite assumee : ajouter un endpoint « en attente pour ce devis »
 * la leverait le jour ou elle genera.
 */

const PREFIXE = 'devis:validation-en-attente:';

/**
 * Une validation est reprenable si elle attend TOUJOURS et porte quelque chose
 * a montrer. Tout le reste — appliquee, en erreur, interrompue, introuvable,
 * ou sans proposition — ne l'est pas : proposer une reprise morte vaut moins
 * que ne rien proposer du tout.
 *
 * @param {object|null} etat reponse de GET /api/ai/doc/format/:id/status
 * @returns {boolean}
 */
export const estReprenable = (etat) =>
  Boolean(etat)
  && etat.status === 'awaiting_validation'
  && Array.isArray(etat.propositions)
  && etat.propositions.length > 0;

/**
 * Le stockage local peut lever — navigation privee, cookies bloques. Se
 * souvenir est un confort : il ne doit jamais empecher d'utiliser la fenetre.
 */
const sansEchouer = (action, defaut = null) => {
  try {
    return action();
  } catch (err) {
    return defaut;
  }
};

export const retenir = (submissionId, conversationId) =>
  sansEchouer(() => window.localStorage.setItem(PREFIXE + submissionId, conversationId));

export const relire = (submissionId) =>
  sansEchouer(() => window.localStorage.getItem(PREFIXE + submissionId));

export const oublier = (submissionId) =>
  sansEchouer(() => window.localStorage.removeItem(PREFIXE + submissionId));

export default estReprenable;
